export const rolesPermissions = [
    "company-module",
    "company-profile",
    "admin",
    "settlement",
    "payout-info",
    "abnormal-transaction",
    "disputed-transaction",
    "registration",
    "mapping",
    "location-module",
    "station",
    "charger",
    "network-module",
    "tariff-module",
    "token-module",
    "session-module",
    "log-module",
    "complaint-module",
    "configuration",
]

export const allModulePermissions = [
    "mapping",
    "stakeholder-mapping",
    "power-rating",
    "bulk-actions",
    "price-modification",
    "session-report",
    "log-report",
    "complaint-add",
    "complaint-report",
    "comment-add",
    "settlement-setup",
    "tariff-setup",
    "rate-limit",
]
